import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import { useHistory } from 'react-router-dom'

const CreateSchedulingPoll = ({ order }) => {
  const history = useHistory()
  const { formatMessage } = useIntl()

  const handleClick = () => {
    history.push(`/scheduling-polls/create/calendar?orderId=${order.uid}`)
  }

  return (
    <Menu.Item>
      {(props) => (
        <MenuButton {...props} onClick={handleClick}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default CreateSchedulingPoll
